import { defaultConfig } from '@chakra-ui/react';

import { cardSlotRecipe } from './card';
import { menuSlotRecipe } from './menu';
import { tableSlotRecipe } from './table';

const slotRecipes = {
    ...defaultConfig.theme?.slotRecipes,
    menu: menuSlotRecipe,
    card: cardSlotRecipe,
    table: tableSlotRecipe,
};

export { slotRecipes };
